// Plain-text error from an axios failure: the API's message, else a fallback
export function errorMessage(
  error,
  fallback = "Something went wrong. Try again.",
) {
  const res = error?.response;
  if (res?.status === 429)
    return "Too many requests. Wait a minute and try again.";
  const errors = res?.data?.errors;
  if (errors) {
    const first = Object.values(errors)[0];
    if (Array.isArray(first) && first[0]) return first[0];
  }
  return res?.data?.message || fallback;
}
